/**
 * What a cell, a pair or a field with nothing in it reads as.
 *
 * An em dash, because that is what the wireframes write in every empty cell
 * (AdminLocalitati.tsx `{nKids || '—'}`, AdminCoduri.tsx's own registers) and what half
 * this application already used — `GeographyPage` declared it locally and
 * `HistoryChanges` inlined it, while the medicine registers, the reports register and
 * the expiring-lots table drew a middle dot instead. A middle dot reads as a bullet that
 * lost its list; the two glyphs side by side in one product read as two different
 * meanings for the same nothing.
 *
 * PRODUCT.md's "no em dashes" is a rule about sentences. This is a table's empty-value
 * glyph, not punctuation inside copy.
 *
 * Declared here rather than in any one screen so the next register cannot pick a third
 * character.
 */
export const EMPTY_CELL = '—';
